import { enableProdMode, Injector } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';
import { HttpClientModule } from '@angular/common/http';
import { ConfigServiceService } from './app/services/config-service.service';

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(moduleRef => {
      const injector: Injector = moduleRef.injector;
      // const configService = injector.get(ConfigServiceService);

      // // Call config service and store in localStorage
      // configService.getConfigData().subscribe((data: any) => {
      //   localStorage.setItem('GetConfigData', JSON.stringify(data));
      // });
    })
    .catch(err => console.error(err));
};

// Cordova handling
if (typeof window['cordova'] !== 'undefined') {
  document.addEventListener('deviceready', () => {
    bootstrap();
  }, false);
} else {
  bootstrap();
}

// Register service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('firebase-messaging-sw.js')
    .then((registration) => {
      console.log('service worker Registered', registration);
    }).catch((error) => {
      console.error('service failed', error);
    });
}
